export default "__VITE_ASSET__ef891b3e__"